<template>
    <div style="height: 100vh; width: 100%">
        <l-map ref="myMap" :zoom="zoom" :center="center" :options="mapOptions">
        <l-control-scale position="bottomleft" :maxWidth=150 :imperial="false"></l-control-scale>
        <l-aircraft v-for="(aircraft, index) in acfts" :key="`${aircraft.addr}-${index}`"
        :addr="aircraft.addr"
        :type="aircraft.type"
        :lat-lng="aircraft.position"
        :lat-lngs="aircraft.polyline"
        :spath="true"
        :alive="aircraft.alive"
        :rotate="aircraft.rotate"
        :select="aircraft.select"
        :vpath="aircraft.vpath"
        v-on:aircraft:select="evt($event)"
        />
        <l-control :position="'topcenter'">
            <button class="btn btn-action" v-on:click="$router.go(-1)">
                <i class="icon icon-back"></i>
            </button>
        </l-control>
        <l-control-layers :position="'topleft'" />
        <l-tile-layer
            v-for="layer in layers"
            :key="layer.name"
            :url="layer.url"
            :name="layer.name"
            :options="layer.options"
            :attribution="layer.attribution"
            :visible="layer.visible"
            layer-type="base"
        />
        <l-control v-if="('alive' in this.aselect)||(!this.activity)" :position="'topright'" class="custom-control">
            <div v-if="'alive' in this.aselect" class=select>
                <div class="center">
                    <div><b>{{this.aselect.reg}}</b></div>
                    <div><b>{{this.aselect.acft}}</b></div>
                </div>
                <div><u>Elev (QNH)</u>: <b>{{altconv(this.aselect.alt, this.imperial)}}</b></div>
                <div><u>Speed</u>: <b>{{gspconv(this.aselect.gsp, this.imperial)}}</b></div>
                <div><u>Climb Rate</u>: <b>{{clrconv(this.aselect.clr, this.imperial)}}</b></div>
                <div><u>Signal State</u>:
                  <div class="circle" :style="{backgroundColor: color}"></div>
                  <b><span :style="{color: color}"> {{this.state}}</span></b>
                </div>
                <div>{{this.aselect.utc}}</div>
            </div>
            <div v-if="!this.activity" class="no-activity">
                No activity @ {{this.code}}
            </div>
        </l-control>
        </l-map>
    </div>
</template>

<script>
import { altconv, gspconv, clrconv } from '@/utils/external.js'
import { LMap, LControl, LControlLayers, LTileLayer, LControlScale} from 'vue2-leaflet';
import LAircraft from '@/components/aircraft.vue';
import { latLng } from "leaflet";
import axios from 'axios';

const api_url = process.env.VUE_APP_LIVEURL
let interval="" 
let polling_time=5000
let error_time=2000

var acft_idx = {}

export default {
    name: 'Map',
    components: {
                LMap,
                LAircraft,
                LControl,
                LControlLayers,
                LTileLayer,
                LControlScale
    },
    data () {
        return {
            mapOptions: {
                zoomSnap: 0.5,
                zoomControl: false
            },
            zoom: 12,
            center: latLng(47.79861666666667, 3.7813333333333334),
            last_select: null,
            devices: [],
            acfts: [],
            aselect: {},
            code: null,
            activity: true,
            imperial: false,
            layers: [
                {
                    name: 'Esri',
                    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                    options: {maxNativeZoom: 15},
                    attribution: '<a href="http://www.esri.com/" target="_blank">Esri</a>',
                    subdomains: 'a,b,c',
                    visible: false
                },
                {
                    name: 'Stamen',
                    url: 'https://tiles.stadiamaps.com/tiles/stamen_terrain/{z}/{x}/{y}{r}.png',
                    options: {maxNativeZoom: 12},
                    attribution: '&copy; <a href="https://stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; \
                    <a href="https://stamen.com/" target="_blank">Stamen Design</a> &copy; \
                    <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; \
                    <a href="https://www.openstreetmap.org/about" target="_blank">OpenStreetMap</a> contributors',
                    visible: false
                },
                {
                    name: 'OpenTopoMap',
                    url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
                    attribution: '<a href="http://opentopomap.org" target="_blank">OpenTopoMap</a>',
                    options: {maxNativeZoom: 15},
                    subdomains: 'a,b,c',
                    visible: false
                },
                {
                    name: 'OpenStreetMap',
                    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>',
                    visible: true
                }
            ],
        }
    },
    computed: {
        state () {
                  return (this.aselect.alive ? "Online" : "Offline")
        },
        color () {
               return (this.aselect.alive ? '#7a7acf' : 'red')
        },
    },
    mounted (){
        this.imperial = this.$store.getters.imperial
        this.code = this.$route.params.code
        this.polling(true)
        interval = setInterval(function (){this.polling(false)}.bind(this), polling_time)
    },
    beforeDestroy () {
        clearInterval(interval)
    },
    methods: {
            evt(evt) {
                let idx = acft_idx[evt]
                this.acfts[idx].select = true
                this.aselect = this.acfts[idx]
                this.path(evt)
                if ((this.last_select) && (this.last_select != evt)) {
                    let last_idx = acft_idx[this.last_select]
                    this.acfts[last_idx].select = false
                    }
                else if (this.last_select) this.acfts[idx].vpath = !this.acfts[idx].vpath
                this.last_select = evt
            },
            polling(init_){
                var init = init_
                let prom = axios.get([api_url, 'fleet', this.code].join('/'), {timeout: error_time})
                prom
                .then (response => {
                    let data = response.data
                    let fitbound = []
                    let n = 0
                    let m = this.acfts.length
                    this.acfts = data.map(obj => {
                        let ret = Object.assign({}, obj)
                        ret['rotate'] = obj.track
                        ret['position'] = latLng(obj.lat, obj.lng)
                        if (init){
                            fitbound.push([obj.lat, obj.lng])
                            ret['select'] = false
                            ret['vpath'] = false
                            ret['polycomplete'] = false
                            ret['polyline'] = [[obj.lat, obj.lng]]
                            acft_idx[obj.addr] = n
                            n += 1
                        }
                        else{
                            let idx = acft_idx[obj.addr]
                            if (idx === undefined) {
                                // case new aircraft appears in fleet response
                                ret['select'] = false
                                ret['vpath'] = false
                                ret['polycomplete'] = false
                                ret['polyline'] = [[obj.lat, obj.lng]]
                                acft_idx[obj.addr] = m
                                m += 1
                                }
                            else {
                                // case aircraft was already in index
                                ret['polyline'] = this.acfts[idx].polyline.slice()
                                let old_lat = (this.acfts[idx]).position.lat
                                let old_lng =  (this.acfts[idx]).position.lng
                                if ((old_lat != obj.lat)&&(old_lng != obj.lng)){
                                    ret['polyline'].push([obj.lat, obj.lng])
                                }
                                ret['select'] = (this.acfts[idx]).select
                                ret['vpath'] = (this.acfts[idx]).vpath
                                ret['polycomplete'] = (this.acfts[idx]).polycomplete
                                acft_idx[obj.addr] = n
                                n += 1
                            }
                        }
                        //acft_idx[obj.addr] = n
                        //n += 1
                        return ret
                    })
                    if (init) {
                        if (fitbound.length >=2) this.$refs.myMap.mapObject.fitBounds(fitbound)
                        else if (fitbound.length ==1) this.$refs.myMap.mapObject.panTo(this.acfts[0].position)
                        else {
                            let prom = axios.get([api_url, 'airfield', this.code].join('/'), {timeout: error_time})
                            prom.then (response => {
                                let data = response.data
                                data !== null ? this.center=latLng(data[0], data[1]) : ''    
                                })
                            .catch(error => {console.log("Error while consuming live path Api:" + error)})
                            }
                    }
                    this.acfts.length == 0 ? this.activity = false : this.activity = true
                    if (this.last_select){
                        let idx = acft_idx[this.last_select]
                        this.aselect = this.acfts[idx]
                        }
                })
                .catch(error => {
                    console.log("Error while consuming live maddress Api:" + error)
                })
            },
            path(addr){
                let idx = acft_idx[addr]
                if (this.acfts[idx].polycomplete) return
                let prom = axios.get([api_url, 'path', addr, '-30'].join('/'), {timeout: error_time})
                prom.then (response => {
                    let data = response.data
                    if (data.poly) {
                        this.acfts[idx].polycomplete = true
                        let new_poly = data.poly.slice()
                        this.acfts[idx].polyline = new_poly
                    }
                })
                .catch(error => {console.log("Error while consuming live path Api:" + error)})
            },
            altconv: altconv,
            gspconv: gspconv,
            clrconv: clrconv
    }
}
</script>

<style scoped>
.circle {
    width: 10px;
    height: 10px;
    border-radius: 5px;
    display: inline-block;
}
.center {
  text-align: center;
}
.custom-control {
  background: #fff;
  border: 2px solid rgba(0,0,0,.2);
  border-radius: 0.5em;
  width: 150px;
  text-align: left;
}
.leaflet-control-scale {
    background-color: white;
}
.select {
    padding: 0.5em 0.5em;
}
.no-activity {
    text-align: center;
    color: red;
    font-weight: bold;
    background-color:orange;
    border-radius: 0.5em;
    padding-top: 6px;
    padding-bottom: 6px;
}
</style>